import { DotLoader } from '@lifeomic/chroma-react/components/DotLoader';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import React from 'react';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

export const LoadingContainer = () => {
  const classes = useStyles({});
  return (
    <div className={classes.root}>
      <DotLoader />
    </div>
  );
};
